/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './catalog-definitions.reducer';

export const CatalogDefinitionsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const catalogDefinitionsEntity = useAppSelector(state => state.catalogDefinitions.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="catalogDefinitionsDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.catalogDefinitions.detail.title">CatalogDefinitions</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.id">Id</Translate>
            </span>
          </dt>
          <dd>{catalogDefinitionsEntity.id}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.code">Code</Translate>
            </span>
            <UncontrolledTooltip target="code">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.code" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.code}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.name}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.description">Description</Translate>
            </span>
            <UncontrolledTooltip target="description">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.description" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.description}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="draft">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.draft">Draft</Translate>
            </span>
            <UncontrolledTooltip target="draft">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.draft" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.draft ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{catalogDefinitionsEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.timestampEntry}</dd>
          <dt>
            <span id="addedById">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.addedById">Added By Id</Translate>
            </span>
            <UncontrolledTooltip target="addedById">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.addedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.addedById}</dd>
          <dt>
            <span id="modifiedById">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.modifiedById">Modified By Id</Translate>
            </span>
            <UncontrolledTooltip target="modifiedById">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.modifiedById" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.modifiedById}</dd>
          <dt>
            <span id="addedByType">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.addedByType">Added By Type</Translate>
            </span>
            <UncontrolledTooltip target="addedByType">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.addedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.addedByType}</dd>
          <dt>
            <span id="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.modifiedByType">Modified By Type</Translate>
            </span>
            <UncontrolledTooltip target="modifiedByType">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.modifiedByType" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.modifiedByType}</dd>
          <dt>
            <span id="tenantId">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.tenantId">Tenant Id</Translate>
            </span>
            <UncontrolledTooltip target="tenantId">
              <Translate contentKey="tinyMedicRestApp.catalogDefinitions.help.tenantId" />
            </UncontrolledTooltip>
          </dt>
          <dd>{catalogDefinitionsEntity.tenantId}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.catalogDefinitions.catalogType">Catalog Type</Translate>
          </dt>
          <dd>{catalogDefinitionsEntity.catalogType ? catalogDefinitionsEntity.catalogType.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.catalogDefinitions.category">Category</Translate>
          </dt>
          <dd>{catalogDefinitionsEntity.category ? catalogDefinitionsEntity.category.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/catalog-definitions" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/catalog-definitions/${catalogDefinitionsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default CatalogDefinitionsDetail;
